import {
    licensesClassifierFulfilledConstants,
    licensesClassifierPendingConstants,
    licensesClassifierRejectedConstants,
} from '../actions';

const initialState = {
    data: {},
    error: '',
    loading: true
};

export default function (state = initialState, action) {
    switch (action.type) {

        case licensesClassifierPendingConstants.PRODUCT_ATTRIBUTE_LOADED:
        case licensesClassifierPendingConstants.PRODUCT_VERSION_LOADED:
        case licensesClassifierPendingConstants.PRODUCT_NAME_LOADED:
            return initialState;

        case licensesClassifierPendingConstants.PRODUCT_ATTRIBUTE_CREATED:
        case licensesClassifierPendingConstants.PRODUCT_ATTRIBUTE_UPDATED:
        case licensesClassifierPendingConstants.PRODUCT_ATTRIBUTE_DELETED:
        case licensesClassifierPendingConstants.PRODUCT_VERSION_CREATED:
        case licensesClassifierPendingConstants.PRODUCT_VERSION_UPDATED:
        case licensesClassifierPendingConstants.PRODUCT_VERSION_DELETED:
        case licensesClassifierPendingConstants.PRODUCT_NAME_CREATED:
        case licensesClassifierPendingConstants.PRODUCT_NAME_UPDATED:
        case licensesClassifierPendingConstants.PRODUCT_NAME_DELETED:
            return { ...state, loading: true };

        case licensesClassifierFulfilledConstants.PRODUCT_NAME_LOADED:
            return {
                ...initialState,
                data: {
                    ...state.data,
                    total: action.payload.total,
                    licenseProductNames: [].concat(action.payload.licenseProductNames).sort((a, b) => {
                        if (a.licenseProductName < b.licenseProductName) return -1;
                        if (a.licenseProductName > b.licenseProductName) return 1;
                        return 0;
                    }),
                },
                loading: false
            };

        case licensesClassifierFulfilledConstants.PRODUCT_ATTRIBUTE_LOADED:
            return {
                ...initialState,
                data: {
                    ...state.data,
                    total: action.payload.total,
                    licenseProductAttributes: [].concat(action.payload.licenseProductAttributes).sort((a, b) => {
                        if (a.licenseProductAttribute < b.licenseProductAttribute) return -1;
                        if (a.licenseProductAttribute > b.licenseProductAttribute) return 1;
                        return 0;
                    }),
                },
                loading: false
            };

        case licensesClassifierFulfilledConstants.PRODUCT_VERSION_LOADED:
            return {
                ...initialState,
                data: {
                    ...state.data,
                    total: action.payload.total,
                    licenseProductVersionNames: [].concat(action.payload.licenseProductVersionNames).sort((a, b) => {
                        if (a.licenseProductName < b.licenseProductName) return -1;
                        if (a.licenseProductName > b.licenseProductName) return 1;
                        return 0;
                    }),
                },
                loading: false
            };

        case licensesClassifierFulfilledConstants.PRODUCT_VERSION_CREATED:
            return {
                ...initialState,
                loading: false,
                data: {
                    ...state.data,
                    total: action.payload.total,
                    licenseProductVersionNames: [
                        ...state.data.licenseProductVersionNames,
                        action.payload],
                }
            };

        case licensesClassifierFulfilledConstants.PRODUCT_NAME_CREATED:
            return {
                ...initialState,
                loading: false,
                data: {
                    ...state.data,
                    total: action.payload.total,
                    licenseProductNames: [
                        ...state.data.licenseProductNames,
                        action.payload.licenseProductNames],
                }
            };

        case licensesClassifierFulfilledConstants.PRODUCT_ATTRIBUTE_CREATED:
            return {
                ...initialState,
                loading: false,
                data: {
                    ...state.data,
                    total: action.payload.total,
                    licenseProductAttributes: [
                        ...state.data.licenseProductAttributes,
                        action.payload.licenseProductAttributes],
                }
            };

        case licensesClassifierFulfilledConstants.PRODUCT_NAME_UPDATED:
            return {
                ...state,
                loading: false,
                data: {
                    ...state.data,
                    licenseProductNames:
                        state.data.licenseProductNames.map(c => (c.id === action.payload.id ? action.payload : c)),
                }
            };

        case licensesClassifierFulfilledConstants.PRODUCT_ATTRIBUTE_UPDATED:
            return {
                ...state,
                loading: false,
                data: {
                    ...state.data,
                    licenseProductAttributes:
                        state.data.licenseProductAttributes.map(c => (c.id === action.payload.id ? action.payload : c)),
                }
            };

        case licensesClassifierFulfilledConstants.PRODUCT_VERSION_UPDATED:
            return {
                ...state,
                loading: false,
                data: {
                    ...state.data,
                    licenseProductVersionNames:
                        state.data.licenseProductVersionNames.map(
                            c => (c.id === action.payload.id ? action.payload : c)
                        ),
                }
            };

        case licensesClassifierFulfilledConstants.PRODUCT_NAME_DELETED:
            return {
                ...state,
                data: {
                    ...state.data,
                    licenseProductNames:
                        state.data.licenseProductNames.filter(c => c.id !== action.payload),
                },
                loading: false
            };

        case licensesClassifierFulfilledConstants.PRODUCT_ATTRIBUTE_DELETED:
            return {
                ...state,
                data: {
                    ...state.data,
                    licenseProductAttributes:
                        state.data.licenseProductAttributes.filter(c => c.id !== action.payload),
                },
                loading: false
            };

        case licensesClassifierFulfilledConstants.PRODUCT_VERSION_DELETED:
            return {
                ...state,
                data: {
                    ...state.data,
                    licenseProductVersionNames:
                        state.data.licenseProductVersionNames.filter(c => c.id !== action.payload),
                },
                loading: false
            };

        case licensesClassifierRejectedConstants.PRODUCT_ATTRIBUTE_DELETED:
        case licensesClassifierRejectedConstants.PRODUCT_ATTRIBUTE_UPDATED:
        case licensesClassifierRejectedConstants.PRODUCT_ATTRIBUTE_CREATED:
        case licensesClassifierRejectedConstants.PRODUCT_ATTRIBUTE_LOADED:
        case licensesClassifierRejectedConstants.PRODUCT_VERSION_DELETED:
        case licensesClassifierRejectedConstants.PRODUCT_VERSION_UPDATED:
        case licensesClassifierRejectedConstants.PRODUCT_VERSION_CREATED:
        case licensesClassifierRejectedConstants.PRODUCT_VERSION_LOADED:
        case licensesClassifierRejectedConstants.PRODUCT_NAME_DELETED:
        case licensesClassifierRejectedConstants.PRODUCT_NAME_UPDATED:
        case licensesClassifierRejectedConstants.PRODUCT_NAME_CREATED:
        case licensesClassifierRejectedConstants.PRODUCT_NAME_LOADED: {
            const error = action.payload;

            if (error.response) {
                return {
                    ...state,
                    loading: false,
                    error: `${error.response.data.errorMessage || error.response.status + ' ' + error.response.statusText}`,
                    ...error.response.data
                };
            } else if (error) {
                return {
                    ...state,
                    loading: false,
                    error: error.message
                };
            }

            return state;
        }

        default:
            return state;
    }
}
